<template>
  <div class="onboarding-slide1">
    <img class="icon" :src="currencyIcon" />
    <div class="content" @click="$emit('next')">
      <p class="title">{{ currencyNameTranslated($t) }}</p>
      <p
        v-t="{ path: 'components.onboarding.default.slide1.welcome' }"
        class="welcome-text"
      />
      <p
        v-t="{ path: 'components.onboarding.default.slide1.text' }"
        class="mx-1 text-base font-bold text"
      />
      <img src="/img/onboarding/slide1.png" class="mx-auto" />

      <p
        v-t="{ path: 'components.onboarding.default.slide1.bottom_text' }"
        class="mx-8 mt-6 text"
      />
      <p
        v-t="{ path: 'components.onboarding.default.thanks' }"
        class="thanks"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia'

export default {
  emits: ['next'],
  computed: {
    ...mapState(useMeStore, ['currencyIcon', 'currencyNameTranslated']),
  },
}
</script>

<style lang="scss" scoped>
.onboarding-slide1 {
  @apply px-4;
  height: 30rem;
}

.content {
  @apply bg-white px-6 shadow-box-lg -mt-12 pt-12 rounded-theme-small relative;
  height: 26rem;
}

.icon {
  @apply mx-auto h-24 z-20 relative;
}

.title {
  @apply text-theme-primary font-theme-title text-4xl text-center uppercase;
}

.welcome-text {
  @apply text-theme-primary text-base text-center mb-4 font-bold;
}

.text {
  @apply text-theme-primary text-center;
}

.thanks {
  @apply absolute text-theme-primary font-black text-base text-center bottom-0 left-0 right-0 pb-4 cursor-pointer w-full;
}
</style>
